"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n            color: ", ";\n            background: ", ";\n            padding: ", "em ", "em;\n            border-radius: ", "em;\n            transform: translateX(-50%);\n            position: absolute;\n            opacity: 0.9;\n            &:after {\n                content: \" \";\n                position: absolute;\n                bottom: -9px;\n                border-top: 10px ", " solid;\n                border-left: 10px solid transparent;\n                border-right: 10px solid transparent;\n                left: 50%;\n                margin-right: -50%;\n                transform: translateX(-50%);\n            }\n        "], ["\n            color: ", ";\n            background: ", ";\n            padding: ", "em ", "em;\n            border-radius: ", "em;\n            transform: translateX(-50%);\n            position: absolute;\n            opacity: 0.9;\n            &:after {\n                content: \" \";\n                position: absolute;\n                bottom: -9px;\n                border-top: 10px ", " solid;\n                border-left: 10px solid transparent;\n                border-right: 10px solid transparent;\n                left: 50%;\n                margin-right: -50%;\n                transform: translateX(-50%);\n            }\n        "]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _animateCssStyledComponents = require("animate-css-styled-components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tooltip = function (_React$Component) {
    _inherits(Tooltip, _React$Component);

    function Tooltip(props) {
        _classCallCheck(this, Tooltip);

        var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

        _this.state = {
            x: 0,
            y: 0,
            visible: false
        };
        return _this;
    }

    // Update position of the tooltip


    _createClass(Tooltip, [{
        key: "_onMouseMove",
        value: function _onMouseMove(e) {
            var height = this.tooltipElement ? this.tooltipElement.clientHeight : 9999;

            this.setState({
                x: e.pageX,
                y: e.pageY,
                visible: true,
                height: height
            });
        }

        // Remove the tooltip when not hovering

    }, {
        key: "_onMouseLeave",
        value: function _onMouseLeave() {
            this.setState({ visible: false });
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var theme = this.props.theme;


            var TooltipText = _styledComponents2.default.div(_templateObject, theme.tooltip.color, theme.tooltip.background, theme.tooltip.padding / 2, theme.tooltip.padding, theme.tooltip.radius, theme.tooltip.background);

            var coords = {
                top: this.state.y - (this.state.height + 40),
                left: this.state.x
            };

            return _react2.default.createElement(
                "span",
                {
                    onMouseMove: function onMouseMove(e) {
                        return _this2._onMouseMove(e);
                    },
                    onMouseLeave: function onMouseLeave() {
                        return _this2._onMouseLeave();
                    }
                },
                this.state.visible && _react2.default.createElement(
                    TooltipText,
                    {
                        style: coords,
                        onMouseMove: function onMouseMove(e) {
                            return e.stopPropagation();
                        },
                        innerRef: function innerRef(tooltipElement) {
                            return _this2.tooltipElement = tooltipElement;
                        }
                    },
                    this.props.text
                ),
                this.props.children
            );
        }
    }]);

    return Tooltip;
}(_react2.default.Component);

Tooltip.displayName = "Tooltip";

exports.default = (0, _styledComponents.withTheme)(Tooltip);


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/tooltip.js
// module id = 1023
// module chunks = 95715928098905 168707334958949